import * as XLSX from 'xlsx';

// A conversion is read from this sheet: its first row names one AIF per column after "Fund name".
export const AIF_TEMPLATE_SHEET = 'AIF Template';

const LABEL = 'fund name';
// Unused template columns are headed "[blank]" and are not AIFs.
const PLACEHOLDER = /^\[.*\]$/;
const HEADER_ROWS = 5;

export function readTemplateFunds(workbook) {
  const sheet = workbook?.Sheets?.[AIF_TEMPLATE_SHEET];
  if (!sheet) return { hasTemplate: false, funds: [] };

  const range = XLSX.utils.decode_range(sheet['!ref'] || 'A1');
  range.e.r = Math.min(range.e.r, range.s.r + HEADER_ROWS - 1);
  const rows = XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    range: XLSX.utils.encode_range(range),
    blankrows: false,
    defval: ''
  });

  for (const row of rows) {
    const at = row.findIndex(cell => String(cell).trim().toLowerCase() === LABEL);
    if (at < 0) continue;
    const funds = row
      .slice(at + 1)
      .map(cell => String(cell).trim())
      .filter(name => name && !PLACEHOLDER.test(name));
    return { hasTemplate: true, funds: [...new Set(funds)] };
  }
  return { hasTemplate: true, funds: [] };
}

const loosely = name =>
  String(name || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

// Each AIF of the period against the template's columns, and the columns no AIF answers to.
export function compareTemplateFunds(aifNames, columns) {
  const used = new Set();
  const aifs = aifNames.map(name => {
    const exact = columns.find(column => !used.has(column) && column === String(name).trim());
    if (exact) {
      used.add(exact);
      return { name, state: 'found' };
    }
    const near = columns.find(column => !used.has(column) && loosely(column) === loosely(name));
    if (near) {
      used.add(near);
      return { name, state: 'renamed', column: near };
    }
    return { name, state: 'missing' };
  });
  return { aifs, extra: columns.filter(column => !used.has(column)) };
}
